import { ConvertUtils } from 'cc-common';
import { Transform, Type } from 'class-transformer';
import { AllowActionResultDto } from '../../common/allow-action-result-dto';

export class CashReceiptResultDto extends AllowActionResultDto {
    cmCashReceiptId: number;
    managementCompanyId: number;
    communityId: number;

    @Type(() => Date)
    receiveDate: Date;

    @Type(() => Date)
    postDate: Date;

    payer: string;
    paymentMethod: string;

    @Type(() => Date)
    transactionDate: Date;

    transactionNumber: string;
    isDeposited: boolean;
    amount: number;
    description: string;

    @Type(() => Date)
    reversedDate: Date;

    @Transform(ConvertUtils.toNullableString)
    customer: string;

    defaultBankName: string;

    allowLimitedEdit: boolean;
    allowEdit: boolean;
    allowDelete: boolean;
    allowReverse: boolean;

    @Type(() => Date)
    updatedTime: Date;

    id: string;
    displayName: string;
    infoUrl: string;
    profileApproved: boolean;
}
